var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentSalaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 10.6673C11.6665 9.93065 9.57717 9.33398 6.99984 9.33398M11.6665 10.6673C11.6665 11.404 9.57717 12.0007 6.99984 12.0007C4.4225 12.0007 2.33317 11.404 2.33317 10.6673M11.6665 10.6673V13.9587C11.6665 14.718 9.57717 15.334 6.99984 15.334C4.4225 15.334 2.33317 14.7187 2.33317 13.9587V10.6673M11.6665 10.6673C14.2158 10.6673 16.3332 10.0093 16.3332 9.33398V2.66732M6.99984 9.33398C4.4225 9.33398 2.33317 9.93065 2.33317 10.6673M6.99984 9.33398C4.0545 9.33398 1.6665 8.67598 1.6665 8.00065V4.66732M6.99984 3.33398C4.0545 3.33398 1.6665 3.93065 1.6665 4.66732M1.6665 4.66732C1.6665 5.40398 4.0545 6.00065 6.99984 6.00065C6.99984 6.67598 9.1685 7.33398 11.7178 7.33398C14.2672 7.33398 16.3332 6.67598 16.3332 6.00065M16.3332 2.66732C16.3332 1.93065 14.2665 1.33398 11.7178 1.33398C9.16917 1.33398 7.1025 1.93065 7.1025 2.66732M16.3332 2.66732C16.3332 3.40398 14.2665 4.00065 11.7178 4.00065C9.16917 4.00065 7.1025 3.40398 7.1025 2.66732M7.1025 2.66732V9.44465",
    stroke: "#3969C7",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentSalaryIcon);
export default __webpack_public_path__ + "static/media/CurrentSalaryIcon.88ea752cf7632817e95b1ad83d663940.svg";
export { ForwardRef as ReactComponent };